<template>
  <div class="px-2 py-2">
    <div class="flex flex-col gap-2">
      <div class="h-50 w-full shrink-0">
        <LazyImage
          :url="catalog?.media"
          class="[.loaded]:bg-white [.error]:bg-gray-100 [.error]:dark:bg-neutral-800 h-full w-full rounded-lg"
          image-class="object-cover h-full w-full"
        />
      </div>
      <div class="mt-2 w-full px-2 pb-2">
        <h3 class="mb-1 line-clamp-2 w-full text-base leading-[1.2]">
          {{ catalog.name }}
        </h3>
        <p
          class="mb-1 w-full text-sm font-semibold text-gray-400 dark:text-neutral-400 line-clamp-1"
        >
          {{ catalog.address }}
        </p>
        <div class="flex items-center justify-between text-sm">
          <span class="text-gray-500 dark:text-neutral-400"
            >{{ $t('titles.Available') }}: {{ catalog.free_count }}</span
          >
          <span>
            {{ $t('control.from') }}
            {{
              $formatCompactCurrency(
                catalog.min_price * 1,
                catalog.currency,
                $i18n.locale
              )
            }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LazyImage from '@/components/ui/LazyImage';

export default {
  name: 'CatalogTooltip',
  components: {
    LazyImage,
  },
  props: {
    catalog: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {};
  },

  methods: {},
  computed: {},
};
</script>
